<template>
	<div class="app-warp">
  		<van-nav-bar
  		  	:left-text="!$route.meta.notBack ? '返回' : ''"
  		  	:left-arrow="!$route.meta.notBack"
  			:title="this.$route.meta.title"
  			@click-left="onClickLeft"
  			v-if="!isWechat"
  		/>
  		<div :class="'app-main ' + (isWechat ? 'app-wx-main' : '')" id="js-app-main">
			<router-view />
			<div class="app-position-msg"  @click="prerviewImages" >
				<van-icon name="service-o" color="#fff" size="24" /><span>在线客服</span>
			</div>
			<div style="text-align: center; font-size: 12px;color: #999;">
<!--				<p style="margin: 0;">备案信息 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19037237号-9</a></p>-->
				<!-- <p style="margin: 0; display: flex;align-items: center;justify-content: center;">本网站由 <a href="https://www.upyun.com/?utm_source=lianmeng&utm_medium=referral" target="_blank"><img src="/static/upyun_logo2.png" width="40px" height="20px" /></a>提供CDN加速/云存储服务</p> -->
			</div>
		</div>
		<van-tabbar safe-area-inset-bottom v-model="tabbar_active" class="iphone-tabbar"  v-if="$route.meta.isShowTabbar" :fixed="false">
			<van-tabbar-item name="home" replace :to="'/' + shop_id" icon="home-o">首页</van-tabbar-item>
			<van-tabbar-item name="product" replace :to="'/' + shop_id + '/product'" icon="bag-o">商品{{$route.meta.num}}</van-tabbar-item>
			<van-tabbar-item name="me"  replace :to="'/' + shop_id + '/me'" icon="user-circle-o">订单</van-tabbar-item>
		</van-tabbar>
	</div>
</template>
<script>
	import { Notify,ImagePreview } from 'vant';
	export default {
		name: 'Layout',
		data(){
			return {
				shop_id:'',
				tabbar_config:{
					'首页' : 'home',
					'商品' : 'product',
					'订单' : 'me',
				}
			}
		},
		computed:{
			tabbar_active:{
				get(){
					return this.$route.name;
				},
				set(){

				}
			},
			isWechat: function() {
				//获取user-agaent标识头
				var ua = window.navigator.userAgent.toLowerCase();
				//判断ua和微信浏览器的标识头是否匹配
				if (/micromessenger/.test(ua)) {
					return true;
				} else {
					return false;
				}
			},
			shopInfo(){
				let item = this.$store.getters.shop || {};
				let data = {};
				for(let i in item) {
					data[i.replace('shop_', '')] = item[i];
				}
				return data;
			},
		},
		methods:{
			prerviewImages(){
				/*wx.previewImage({
					current: this.shopInfo.msg, // 当前显示图片的 http 链接
					urls: [this.shopInfo.msg] // 需要预览的图片 http 链接列表
				});
				return;*/
				ImagePreview({images:[this.shopInfo.msg],closeable: true});
			},
			onClickLeft(){
				if(this.$route.name == 'payVipCodeStatus') {
					this.$router.replace({path: '/' + this.shop_id + '/me'});
				}else {
					this.$router.back();
				}
			},
		},
		created(){
			this.$store.getters.token && this.$store.dispatch('user/userinfo');
			try{
				if(this.$route.params && this.$route.params.shopid) {
					this.shop_id = this.$route.params.shopid;

					/// 完全禁掉
					if(this.shop_id == 'xiaozhan') {
						this.$router.replace({path: '/404'});
						return;
					}

					this.$store.dispatch('shop/setShopId', this.shop_id);
		  			this.$store.dispatch('shop/getShopInfo', this.shop_id).then((res) => {
		  				let $favicon = document.querySelector('link[type="image/x-icon"]');
		  				if ($favicon) {
		  					$favicon.href = res.shop_logo;
					    }
		  				this.$store.dispatch('product/getPorduct', this.shop_id).then((_res) => {
		  					
		  				}).catch((_res) => {
		  					Notify({ type: 'warning', message: _res.message });
		  				})
		  			}).catch((res) => {
		  				Notify({ type: 'warning', message: res.message });
		  			})
				}
				this.tabbar_active = this.tabbar_config[this.$route.name];
			}catch(e){}
		}
	}
</script>
<style>
	body,html {
		height: 100%;
	}
	.app-warp {
		max-width: 480px;
		margin: 0 auto;
		height: 100%;

		display: flex;
		justify-content: center;
		flex-direction: column;
	}
	.iphone-tabbar-box {
/*		max-width: 480px;*/
/*		margin: 0 auto;*/
	}
	.app-warp-wexin {
/*		height: calc(100% - 2.2rem);*/
	}
	.app-position-msg {
		cursor: pointer;
		position: fixed;
		bottom: 7rem;
		border-radius: 3.5rem;
		background-color: #07c160;
		font-size: 12px;
		width: 3.5rem;
		height: 3.5rem;
/*		padding: 7px 15px;*/
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #fff;
		box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.2);
		right: 20px;
	}
	.app-position-msg * {
		padding: 0;
		margin: 0;
/*		line-height: 1;*/
	}
	.app-position-msg span {
		transform: scale(0.85);
	}
	.iphone-tabbar {
		max-width: 480px;
		left: 50%;
		margin-left: -50%;
	}
	.app-main {
		height: 100%;
		background-color: #f2f2f2;
		overflow-y: auto;
	}
	.app-wx-main {
/*		height: calc(100% - 5.2rem);*/
	}
	@media screen and (min-width: 480px) {
		.iphone-tabbar {
			margin-left: -240px;
		}
}
</style>


// WEBPACK FOOTER //
// src/views/layout.vue